import React from 'react';
import PropTypes from 'prop-types';
import { Paragraph, Text } from 'components/core/Typography';
import { Image } from 'components/core/Image';

export function StorageUnitCard({
	size,
	sqFt,
	cuFt,
	looksLike,
	whatWillFit,
	illustration,
}) {
	return (
		<div className="storage-card">
			<div className="storage-card-inner">
				<div className="card-header">
					<div className="card-icon">
						<Image
							src={illustration}
							alt={size}
							className="card-icon-img"
							lazyLoad
						/>
					</div>
					<Paragraph className="card-size-title">{size}</Paragraph>
					<div className="card-measurements">
						<Text className="card-measurement-text">{sqFt}</Text>
						{!!cuFt && (
							<>
								<div className="card-divider">
									<svg
										aria-hidden="true"
										width="12"
										height="1"
										fill="none"
										preserveAspectRatio="none"
										role="presentation"
										viewBox="0 0 12 1"
									>
										<line
											stroke="#0B2C5A"
											strokeOpacity="0.2"
											x2="12"
											y1="0.5"
											y2="0.5"
										/>
									</svg>
								</div>
								<Text className="card-measurement-text">
									{cuFt}
								</Text>
							</>
						)}
					</div>
				</div>

				<div className="card-details">
					<div className="card-details-inner">
						<div className="card-detail-section">
							<Text className="card-detail-heading">
								Looks Like:
							</Text>
							<Paragraph className="card-detail-text">
								{looksLike}
							</Paragraph>
						</div>
						<div className="card-detail-section">
							<Text className="card-detail-heading">
								What Will Fit:
							</Text>
							<Paragraph className="card-detail-text">
								{whatWillFit}
							</Paragraph>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

StorageUnitCard.propTypes = {
	size: PropTypes.string.isRequired,
	sqFt: PropTypes.string.isRequired,
	cuFt: PropTypes.string,
	looksLike: PropTypes.string.isRequired,
	whatWillFit: PropTypes.string.isRequired,
	illustration: PropTypes.string.isRequired,
};

export default StorageUnitCard;
